import { Cookies } from 'react-cookie';
import APIService from '../../services/api';
import { handleError } from '../infos/actions';
import {
    POINT_DELETED,
    POINT_DELETING,
    POINT_DOWNLOADED,
    POINT_EDITING,
    POINT_FAILED,
    POINT_FOCUS,
    POINT_MEDIA_DELETED,
    POINT_MEDIA_DELETING,
    POINT_MEDIA_FAILED, POINT_MEDIA_FOCUS,
    POINT_MEDIA_UPLOADED,
    POINT_MEDIA_UPLOADING,
    POINT_POSTING, POINT_RESET,
    POINTS_DOWNLOADED,
    POINTS_FAILED,
    POINTS_PENDING,
    POINTS_RESET,
} from './types';

const cookies = new Cookies();

// Action creators

export const pointsResetAction = () => {
    return {
        type: POINTS_RESET,
    };
};

export const pointResetAction = () => {
    return {
        type: POINT_RESET,
    };
};

export const pointsPendingAction = () => {
    return {
        type: POINTS_PENDING,
    };
};

export const postPointAction = () => {
    return {
        type: POINT_POSTING,
    };
};

export const pointEditingAction = () => {
    return {
        type: POINT_EDITING,
    };
};

export const pointsDownloadedAction = (points, lang) => {
    return {
        type: POINTS_DOWNLOADED,
        payload: {
            lang: lang,
            points: points,
        },
    };
};

export const pointDownloadedAction = (point, lang) => {
    return {
        type: POINT_DOWNLOADED,
        payload: {
            lang: lang,
            point: point,
        },
    };
};

export const deletePointAction = () => {
    return {
        type: POINT_DELETING,
    };
};

export const pointDeletedAction = (id, lang) => {
    return {
        type: POINT_DELETED,
        payload: {
            id: id,
            lang: lang,
        },
    };
};

export const pointFocusAction = (point, lang) => {
    return {
        type: POINT_FOCUS,
        payload: {
            point: point,
            lang: lang,
        },
    };
};

export const pointMediaFocusAction = (media) => {
    return {
        type: POINT_MEDIA_FOCUS,
        payload: media,
    };
};

export const uploadMediaAction = (media) => {
    return {
        type: POINT_MEDIA_UPLOADING,
        payload: media,
    };
};

export const uploadMediaFailedAction = (media) => {
    return {
        type: POINT_MEDIA_FAILED,
        payload: media,
    };
};

export const uploadMediaSucceedAction = (media) => {
    return {
        type: POINT_MEDIA_UPLOADED,
        payload: media,
    };
};

export const deleteMediaAction = () => {
    return {
        type: POINT_MEDIA_DELETING,
    };
};

export const pointMediaDeletedAction = (mediaId) => {
    return {
        type: POINT_MEDIA_DELETED,
        payload: mediaId,
    };
};

// Actions

export function resetPoints() {
    return function (dispatch) {
        dispatch(pointsResetAction());
    };
}

export function resetPoint() {
    return function (dispatch) {
        dispatch(pointResetAction());
    };
}

export function getPoints(app, lang) {
    return function (dispatch) {
        dispatch(pointsPendingAction());
        return APIService
            .getPoints(app, cookies.get('token'), lang)
            .then(points => {
                dispatch(pointsDownloadedAction(points, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, POINTS_FAILED));
            });
    };
}

export function fetchPoint(appId, pointId, lang) {
    return function (dispatch, getState) {
        let points = getState().points.content[lang];
        if (points !== undefined) {
            let point = points.find(function (point) {
                return point.id === pointId;
            });
            if (point !== undefined && point) {
                return dispatch(pointFocusAction(point, lang));
            }
        }
        return dispatch(getPoint(appId, pointId, lang));
    };
}

export function getPoint(appId, pointId, lang) {
    return function (dispatch) {
        dispatch(pointsPendingAction());
        return APIService
            .getPoint(appId, pointId, cookies.get('token'), lang)
            .then(point => {
                dispatch(pointDownloadedAction(point, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, POINT_FAILED));
            });
    };
}

export function deletePoint(appId, pointId, lang) {
    return function (dispatch) {
        dispatch(deletePointAction());
        return APIService
            .deletePoint(appId, pointId, cookies.get('token'), lang)
            .then(() => {
                dispatch(pointDeletedAction(pointId, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, POINT_FAILED));
            });
    };
}

export function putPoint(appId, point, lang) {
    return function (dispatch) {
        dispatch(pointEditingAction());
        return APIService
            .putPoint(appId, point, cookies.get('token'), lang)
            .then(point => {
                dispatch(pointDownloadedAction(point, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, POINT_FAILED));
            });
    };
}

export function postPoint(appId, point, lang) {
    return function (dispatch) {
        dispatch(postPointAction());
        return APIService
            .postPoint(appId, point, cookies.get('token'), lang)
            .then(point => {
                dispatch(pointDownloadedAction(point, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, POINT_FAILED));
            });
    };
}

// MEDIA

export function fetchPointMedia(appId, pointId, mediaId, lang) {
    return function (dispatch, getState) {
        return dispatch(getPointMedia(appId, pointId, mediaId, lang));
    };
}

export function getPointMedia(appId, pointId, mediaId, lang) {
    return function (dispatch) {
        dispatch(pointsPendingAction());
        return APIService
            .getPointMedia(appId, pointId, mediaId, cookies.get('token'), lang)
            .then(media => {
                dispatch(pointMediaFocusAction(media));
            })
            .catch((error) => {
                dispatch(handleError(error, POINTS_FAILED));
            });
    };
}

export function deletePointMedia(appId, pointId, media, lang) {
    return function (dispatch) {
        dispatch(deleteMediaAction());
        return APIService
            .deletePointMedia(appId, pointId, media, cookies.get('token'), lang)
            .then(() => {
                dispatch(pointMediaDeletedAction(media.id));
            })
            .catch((error) => {
                dispatch(handleError(error, POINT_FAILED));
            });
    };
}

export function postPointMedia(appId, pointId, media, lang, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(uploadMediaAction(media));
        if (typeof media === 'string') {
            return APIService
                .postPointLinkMedia(appId, pointId, media, cookies.get('token'), lang)
                .then(point => {
                    dispatch(pointDownloadedAction(point, lang));
                    dispatch(uploadMediaSucceedAction(media));
                })
                .catch((error) => {
                    dispatch(handleError(error));
                    dispatch(uploadMediaFailedAction(media));
                });
        } else {
            return APIService
                .postPointMedia(appId, pointId, media, cookies.get('token'), lang, onUploadProgress)
                .then(point => {
                    dispatch(pointDownloadedAction(point, lang));
                    dispatch(uploadMediaSucceedAction(media));
                })
                .catch((error) => {
                    dispatch(handleError(error));
                    dispatch(uploadMediaFailedAction(media));
                });
        }
    };
}

export function putPointMedia(appId, pointId, media, lang) {
    return function (dispatch) {
        dispatch(uploadMediaAction(media));
        return APIService
            .putPointMedia(appId, pointId, media, cookies.get('token'), lang)
            .then(point => {
                dispatch(pointDownloadedAction(point, lang));
                dispatch(uploadMediaSucceedAction(media));
            })
            .catch((error) => {
                dispatch(handleError(error));
                dispatch(uploadMediaFailedAction(media));
            });
    };
}




// WEBPACK FOOTER //
// src/store/points/actions.js